import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

/*
 * Company details used across the whole site.
 * Replace the placeholders here and every page, title and link follows.
 * Social links point at each platform's homepage until real profile URLs are added.
 * Remove a social entry to hide it everywhere.
 */
export const siteConfig: SiteConfig = {
    name: "YOUR AGENCY NAME",
    description: "A faith-led creative agency for web design, music promotion, digital marketing and branding. We help artists and ambitious brands bring their vision to life.",
    statement: "Creating with purpose. Building with integrity.",
    url: getOrigin(),
    email: 'hello@youragencyname.com',
    responseTime: "within 2 business days",
    ogImage: 'https://pulse-and-purpose.cdn.modulify.website/images/work/afterglow-artist-website.webp',
    socials: [
        { label: 'Instagram', href: 'https://www.instagram.com/' },
        { label: 'TikTok', href: 'https://www.tiktok.com/' },
        { label: 'YouTube', href: 'https://www.youtube.com/' },
        { label: 'LinkedIn', href: 'https://www.linkedin.com/' }
    ]
}
